import { render, staticRenderFns } from "./trainingApplyActivities.vue?vue&type=template&id=1ba8685c"
import script from "./trainingApplyActivities.vue?vue&type=script&lang=js"
export * from "./trainingApplyActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports